import BaseTransform from "@/transforms/modules/base-transform";

export default {
  transformUser(user) {
    return {
      customer_id: BaseTransform.transformNumeric(user, "customer_id"),
      game_id: BaseTransform.transformNumeric(user, "game_id"),
      turns: BaseTransform.transformNumeric(user, "turns"),
      app_id: BaseTransform.transformNumeric(user, "app_id"),
      created: BaseTransform.transformDateFromTimestamp(user, "created"),
      updated_at: BaseTransform.transformDateFromTimestamp(user, "updated_at"),
    };
  },

  transformGame(game) {
    return {
      id: BaseTransform.transformNumeric(game, "id"),
      created: BaseTransform.transformNumeric(game, "created"),
      updated_at: BaseTransform.transformNumeric(game, "updated_at"),
      name: BaseTransform.transformString(game, "name"),
      type: BaseTransform.transformNumeric(game, "type"),
      state: BaseTransform.transformNumeric(game, "state"),
      start_at: BaseTransform.transformNumeric(game, "start_at"),
      end_at: BaseTransform.transformNumeric(game, "end_at"),
      max_game_turns_per_user: BaseTransform.transformNumeric(
        game,
        "max_game_turns_per_user"
      ),
    };
  },

  transformGifts(gifts) {
    let vm = this;
    let result = [];
    if (gifts && gifts.length > 0) {
      gifts.forEach(function (gift) {
        result.push(vm.transformGiftItem(gift));
      });
    }
    result.sort().reverse();
    return result;
  },

  transformHistory(histories) {
    let vm = this;
    let result = [];
    if (histories && histories.length > 0) {
      histories.forEach(function (history) {
        result.push(vm.transformHistoryItem(history));
      });
    }
    return result;
  },

  transformHistoryItem(history) {
    let giftCode = {};
    if (history.gift_code && history.gift_code.done) {
      giftCode = history.gift_code.data;
    }
    let vm = this;
    let details = [];
    let cartStatus = {};
    if (history.cart_status && Object.keys(history.cart_status).length > 0) {
      cartStatus = history.cart_status;
    }
    if (cartStatus.detail && cartStatus.detail.length > 0) {
      cartStatus.detail.forEach(function (detail) {
        details.push(vm.transformHistoryItemDetail(detail));
      });
    }

    return {
      id: BaseTransform.transformNumeric(history, "id"),
      reward_id: BaseTransform.transformNumeric(history, "reward_id"),
      reward: {
        id: BaseTransform.transformString(history.reward, "id"),
        name: BaseTransform.transformString(history.reward, "name"),
        type: BaseTransform.transformNumeric(history.reward, "type"),
      },
      game_id: BaseTransform.transformNumeric(history, "game_id"),
      game: {
        id: BaseTransform.transformString(history.game, "id"),
        name: BaseTransform.transformString(history.game, "name"),
      },
      delivery_code: BaseTransform.transformNumeric(history, "delivery_code"),
      cart_status: {
        created: BaseTransform.transformNumeric(history, "created"),
        id: BaseTransform.transformNumeric(history, "id"),
        linkCart: BaseTransform.transformNumeric(history, "linkCart"),
        pay_status: BaseTransform.transformNumeric(history, "pay_status"),
        pay_time: BaseTransform.transformNumeric(history, "pay_time"),
        transaction_id: BaseTransform.transformNumeric(
          history,
          "transaction_id"
        ),
        is_exist_detail: details.length > 0,
        detail: details,
      },
      state: BaseTransform.transformNumeric(history, "state"),
      customer_id: BaseTransform.transformNumeric(history, "customer_id"),
      created: BaseTransform.transformNumeric(history, "created"),
      updated_at: BaseTransform.transformNumeric(history, "updated_at"),
      delivery: BaseTransform.transformNumeric(history, "delivery"),
      transaction_id: BaseTransform.transformString(history, "transaction_id"),
      is_exist_gift_code: Object.keys(giftCode).length > 0,
    };
  },

  transformHistoryItemDetail(detail) {
    return {
      delivery: BaseTransform.transformString(detail, "delivery"),
      deliveryCode: BaseTransform.transformNumeric(detail, "deliveryCode"),
      id: BaseTransform.transformString(detail, "id"),
      link: BaseTransform.transformString(detail, "link"),
      usage_status: BaseTransform.transformString(detail, "usage_status"),
      usage_status_code: BaseTransform.transformNumeric(
        detail,
        "usage_status_code"
      ),
      using_time: BaseTransform.transformString(detail, "using_time"),
    };
  },

  transformGiftItem(gift) {
    return {
      id: BaseTransform.transformNumeric(gift, "id"),
      created: BaseTransform.transformDateFromTimestamp(gift, "created"),
      updated_at: BaseTransform.transformDateFromTimestamp(gift, "updated_at"),
      name: BaseTransform.transformString(gift, "name"),
      percents: BaseTransform.transformNumeric(gift, "percents"),
      logo: BaseTransform.transformString(gift, "logo"),
      message: BaseTransform.transformString(gift, "message"),
      is_default: BaseTransform.transformNumeric(gift, "is_default"),
      type: BaseTransform.transformNumeric(gift, "type"),
      game_id: BaseTransform.transformNumeric(gift, "game_id"),
      state: BaseTransform.transformNumeric(gift, "state"),
    };
  },

  transformDraw(gift) {
    let giftCode = {};
    if (gift.gift_code && gift.gift_code.done) {
      giftCode = gift.gift_code.data;
    }
    return {
      id: BaseTransform.transformNumeric(gift, "id"),
      cart_id: BaseTransform.transformNumeric(gift, "cart_id"),
      code: BaseTransform.transformString(gift, "code"),
      created: BaseTransform.transformNumeric(gift, "created"),
      updated_at: BaseTransform.transformNumeric(gift, "updated_at"),
      customer_id: BaseTransform.transformNumeric(gift, "customer_id"),
      reward_id: BaseTransform.transformNumeric(gift, "reward_id"),
      game_id: BaseTransform.transformNumeric(gift, "game_id"),
      app_id: BaseTransform.transformNumeric(gift, "app_id"),
      state: BaseTransform.transformNumeric(gift, "state"),
      reward: {
        id: BaseTransform.transformNumeric(gift, "id"),
        created: BaseTransform.transformNumeric(gift, "created"),
        updated_at: BaseTransform.transformNumeric(gift, "updated_at"),
        name: BaseTransform.transformString(gift.reward, "name"),
        logo: BaseTransform.transformString(gift.reward, "logo"),
        message: BaseTransform.transformString(gift.reward, "message"),
        is_default: BaseTransform.transformNumeric(gift.reward, "is_default"),
        type: BaseTransform.transformNumeric(gift.reward, "type"),
        game_id: BaseTransform.transformNumeric(gift.reward, "game_id"),
        state: BaseTransform.transformNumeric(gift.reward, "state"),
        is_partner_gift: BaseTransform.transformString(
          gift.reward,
          "is_partner_gift"
        ),
      },
      gift_code: {
        cart: this.transformCart(giftCode.cart),
        linkCart: BaseTransform.transformString(giftCode, "linkCart"),
        linkCombo: BaseTransform.transformString(giftCode, "linkCombo"),
        linkShippingInfo: BaseTransform.transformString(
          giftCode,
          "linkShippingInfo"
        ),
        transaction_id: BaseTransform.transformString(
          giftCode,
          "transaction_id"
        ),
        pay: BaseTransform.transformNumeric(giftCode, "pay"),
      },
    };
  },

  transformCart(cart) {
    if (!cart || Object.keys(cart).length <= 0) {
      return cart;
    }
    let vm = this;
    let details = [];
    if (cart.code_link_gift && cart.code_link_gift.length > 0) {
      cart.code_link_gift.forEach(function (detail) {
        details.push(vm.transformCartItemDetail(detail));
      });
    }
    return {
      cartNo: BaseTransform.transformNumeric(cart, "cartNo"),
      id: BaseTransform.transformNumeric(cart, "id"),
      link_gift: BaseTransform.transformArray(cart, "link_gift"),
      is_exist_gift: details.length > 0,
      code_link_gift: details,
      money_ship: BaseTransform.transformNumeric(cart, "money_ship"),
      money_total: BaseTransform.transformNumeric(cart, "money_total"),
    };
  },

  transformCartItemDetail(detail) {
    return {
      card_id: BaseTransform.transformNumeric(detail, "card_id"),
      cart_detail_id: BaseTransform.transformNumeric(detail, "cart_detail_id"),
      city_id: BaseTransform.transformNumeric(detail, "city_id"),
      code: BaseTransform.transformString(detail, "code"),
      code_display: BaseTransform.transformString(detail, "code_display"),
      code_display_type: BaseTransform.transformString(
        detail,
        "code_display_type"
      ),
      code_image: BaseTransform.transformString(detail, "code_image"),
      delivery: BaseTransform.transformString(detail, "delivery"),
      deliveryCode: BaseTransform.transformString(detail, "deliveryCode"),
      delivery_note: BaseTransform.transformString(detail, "delivery_note"),
      delivery_tracking: BaseTransform.transformString(
        detail,
        "delivery_tracking"
      ),
      estimateDelivery: BaseTransform.transformString(
        detail,
        "estimateDelivery"
      ),
      expired: BaseTransform.transformString(detail, "expired"),
      link: BaseTransform.transformString(detail, "link"),
      priceId: BaseTransform.transformString(detail, "priceId"),
      pin: BaseTransform.transformString(detail, "pin"),
      serial: BaseTransform.transformString(detail, "serial"),
    };
  },
};
